/**
 * Schema Zod para Registro de Motorista (Etapa 1)
 * Validação de Nome, Telefone, Email e Senha
 */

import { z } from 'zod';

export const registerSchema = z.object({
    full_name: z
        .string()
        .min(3, 'Nome deve ter no mínimo 3 caracteres')
        .max(100, 'Nome muito longo')
        .regex(/^[a-zA-ZÀ-ÿ\s]+$/, 'Nome deve conter apenas letras'),

    phone: z
        .string()
        .regex(/^\(\d{2}\) \d{5}-\d{4}$/, 'Telefone inválido. Use o formato (99) 99999-9999'),

    email: z
        .string()
        .email('Email inválido')
        .max(100, 'Email muito longo')
        .transform((val) => val.toLowerCase().trim()),

    password: z
        .string()
        .min(8, 'Senha deve ter no mínimo 8 caracteres')
        .max(50, 'Senha muito longa')
        .regex(/[A-Z]/, 'Senha deve conter ao menos uma letra maiúscula')
        .regex(/[a-z]/, 'Senha deve conter ao menos uma letra minúscula')
        .regex(/[0-9]/, 'Senha deve conter ao menos um número')
});

// Tipo inferido do schema
export type RegisterFormData = z.infer<typeof registerSchema>;
